// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltips-module__tooltip___2XVPt"};